import './Room.css';
import React, { useContext, useEffect, useState } from 'react';
import { SocketContext } from '../components/SocketContext';
import { useLocation } from 'react-router-dom';
import DrawingCanvas from '../components/DrawingCanvas';
import ViewingCanvas from '../components/ViewingCanvas';
import OverLay from '../components/Overlay';
import PlayerList from '../components/PlayerList';
import StatusBar from '../components/StatusBar';
import WordSelector from '../components/WordSelector';
import ChatAndGuess from '../components/ChatAndGuess';

let roomName = null;
let playerName = null;
let sprite = 0;

const Room = (props) => {
    const socket = useContext(SocketContext);
    const [isDrawing, setIsDrawing] = useState(false);
    const [hasJoinedRoom, setHasJoinedRoom] = useState(false);
    

    let navigateData = useLocation();
    roomName = navigateData.state.name;
    playerName = navigateData.state.playerName;
    sprite = navigateData.state.sprite;
    console.log("Room name: " + roomName + " Player name: " + playerName + " Sprite: " + sprite);
    useEffect(() => {
        
        if (socket) {
            socket.on('isdrawing', () => {
                //console.log("setting isdrawing to true");
                setIsDrawing(true);
            });

            socket.on('isguessing', () => {
                //console.log("setting isdrawing to true");
                setIsDrawing(false);
            });

            if (!hasJoinedRoom) {
                socket.emit("joinroom", { "room": roomName, "playerName": playerName, "sprite": sprite });
                setHasJoinedRoom(true);
            }

            console.log("joining room " + roomName);
        } else {
            console.log("socket is null");
        }

        return () => {
            if (socket) {
                socket.off('isdrawing');
                socket.off('isguessing');
            }
        };

    }, [socket, hasJoinedRoom, isDrawing]);

    return (
        <>
            {socket ? (
                <>
                    <div class="parent">
                        <div class="div1">
                            <img src="littleguy.png" height="75px" alt="Cute baby holding a crayon" style={{float: "left"}} />
                            <div className="roomname" style={{float: "left", margin: "0px 0px 0px 12px"}}>Room: {roomName}</div>
                            <span style={{clear: "left"}} />
                        </div>
                        <div class="div2">
                            <span id="statusbar"><StatusBar socket={socket} /></span>
                        </div>
                        <div class="div3">
                            &nbsp;
                        </div>
                        <div class="div4">
                            <PlayerList room={roomName} />
                        </div>
                        <div class="div5">
                            {isDrawing ? <DrawingCanvas socket={socket} /> : <ViewingCanvas socket={socket} />}
                            <OverLay></OverLay>
                        </div>
                        <div class="div6">
                            <ChatAndGuess />
                        </div>
                        <div class="div7">
                            &nbsp;
                        </div>
                        <div class="div8">
                            <div class="wordselector"><WordSelector /></div>
                        </div>
                        <div class="div9">
                            &nbsp;
                        </div>
                    </div>

                </>
            ) : <div>Connecting...</div>}
        </>
    );

};
export default Room;

